<div class="fm">
  <table class="fm-table" aria-label="Field mapping">
    <thead class="fm-thead">
      <tr>
        <th class="fm-th">Assure Field</th>
        <th class="fm-th">{{ sourceLabel }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let field of fields; trackBy: trackField" class="fm-row">
        <td class="fm-td">
          <div class="fm-label">
            <span class="fm-field-name">{{ field.label }}</span>
            <span *ngIf="showRequiredMark && field.required" class="fm-required" aria-label="required">*</span>
            <img
              class="fm-info"
              src="assets/images/virtusa-icons/info-dark.svg"
              [alt]="field.label + ' field'"
              [title]="field.label + ' field'"
              width="14"
              height="14" />
          </div>
        </td>
        <td class="fm-td">
          <div class="fm-select-wrap">
            <select
              [id]="idPrefix + '-' + field.fieldKey"
              class="fm-select"
              [class.fm-select--filled]="filledSelect"
              [(ngModel)]="mappings[field.fieldKey]"
              [attr.aria-label]="field.label + ' mapping'">
              <option value="">{{ placeholder }}</option>
              <option *ngFor="let column of columns" [value]="column">{{ column }}</option>
            </select>
            <img
              class="fm-select-arrow"
              src="assets/images/virtusa-icons/drop-arrow.svg"
              alt=""
              aria-hidden="true"
              width="12"
              height="8" />
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
